module.exports = __webpack_public_path__ + "static/media/the_invisible_women_article.10e98485.jpg";